export default {
  PROFILE: 'プロフィール',
  PUBLISH_SETTING: '公開先設定',
};
